import { InjectionToken } from '@angular/core';

/**
 * Token used for providing the IEntityListModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: EntityListModuleConfigToken, useValue: entityListModuleConfig },
 * ],
 */
const EntityListModuleConfigToken = new InjectionToken('entity_list_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { EntityListModuleConfigToken };

//# sourceMappingURL=mt-ng2-entity-list-module-config.js.map